import * as React from "react";
import GlobalContext from "../../context/globalContext";
import PropTypes from "prop-types";

import {
  Dialog,
  withTheme,
  // Slide,
  AppBar,
  Toolbar,
  Typography,
  Button,
  List,
  ListItem,
  Avatar,
  ListItemText,
  Divider,
  CircularProgress,
  withStyles,
} from "@material-ui/core";
import {} from "@material-ui/icons";
import { getImageUrl } from "../../framework/getImageUrl";
import s from "./oldShoppingCartDialog.module.css";
import { withRouter } from "react-router";
// import label from '../../framework/whiteLabel'
// import cache, { cacheItems } from '../../framework/cache'
// import { isBrowser } from 'react-device-detect'
// import zIndex from '@material-ui/core/styles/zIndex'

// function Transition(props) {
//   return <Slide direction="right" in={true} {...props} />
// }

class OldShoppingCartDialog extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      updatingNewCart: false,
    };
  }

  useOldShoppingCart = async () => {
    const { previousShoppingCartItems } = this.context.global.data;
    const { modifyShoppingCart, setGlobalState } = this.context.global;

    this.setState({ updatingNewCart: true });

    await Promise.all(
      previousShoppingCartItems.map((m, i) => {
        if (i === previousShoppingCartItems.length - 1) {
          return modifyShoppingCart(
            previousShoppingCartItems[i],
            false,
            previousShoppingCartItems[i].quantity,
            false
          );
        } else {
          return modifyShoppingCart(
            previousShoppingCartItems[i],
            false,
            previousShoppingCartItems[i].quantity,
            true
          );
        }
      })
    );

    await this.context.global.submitShoppingCartChanges();
    await this.context.global.getCurrentShoppingCart();
    this.context.global.getUserFavorites();
    this.context.global.getUserReorderItems();

    setGlobalState("oldShoppingCartDialogState", false);

    setGlobalState("previousShoppingCartItems", null);
    this.setState({ updatingNewCart: false });
  };

  startNewShoppingCart = async () => {
    const { setGlobalState } = this.context.global;
    setGlobalState("oldShoppingCartDialogState", false);
    setGlobalState("previousShoppingCartItems", null);
  };

  render() {
    const { theme, classes } = this.props;
    const {
      oldShoppingCartDialogState,
      previousShoppingCartItems,
    } = this.context.global.data;
    const { updatingNewCart } = this.state;

    return (
      <Dialog
        fullScreen
        open={oldShoppingCartDialogState}
        // open={true}

        onClose={() => this.closeAppMenu()}
        // TransitionComponent={Transition}
        scroll={"paper"}
        style={{
          left: this.state.left,
          zIndex: 90002,
        }}
      >
        <AppBar className={s.oldShoppingCartAppBar} style={{ height: 120 }}>
          <Toolbar className={s.shoppingCartToolbar}>
            <div className={s.appBarContentContainer}>
              <div className={s.addressContainer}>
                <Typography
                  className={s.title}
                  variant="h6"
                  color="inherit"
                  noWrap
                >
                  Welcome Back
                </Typography>
                <Typography className={s.title} variant="body2" color="inherit">
                  We noticed you didn't complete your order from last time.
                  Would you like to start where you left off?
                </Typography>
              </div>
            </div>
            {/* <div className={s.closeButtonContainer}>
            <IconButton color="inherit" onClick={() => this.closeAppMenu()} aria-label="Close" className={s.shoppingCartAppBar}>
              <Close />
            </IconButton>
          </div> */}
          </Toolbar>
        </AppBar>

        <div style={{ marginTop: 130 }} />

        <List className={s.shoppingCartListContainer}>
          {previousShoppingCartItems
            ? previousShoppingCartItems.map((item) => {
                return (
                  <ShoppingListItem
                    key={item.uuid}
                    item={item}
                    theme={theme}
                    addItem={this.addItem}
                    removeItem={this.removeItem}
                  />
                );
              })
            : null}
        </List>

        <div style={{ marginBottom: 120 }} />

        <div
          className={s.copyShoppingCartButtonContainer}
          style={{
            background: `linear-gradient(0.9turn, ${theme.palette.secondary.main} 0%, ${theme.palette.primary.main} 100%`,
          }}
        >
          {updatingNewCart ? (
            <div
              style={{
                // textAlign: 'center',
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignContent: "center",
                padding: ".5rem",
              }}
            >
              <Typography
                className={s.title}
                variant="body1"
                color="white"
                style={{ paddingBottom: 5, color: "white" }}
              >
                Creating your new shopping cart.
              </Typography>
              <CircularProgress
                style={{ color: "white", alignSelf: "center" }}
              />
            </div>
          ) : (
            <>
              <Button
                className={classes.oldShoppingCart_buttons}
                onClick={() => this.useOldShoppingCart()}
              >
                Add To Cart
              </Button>
              <Button
                className={classes.oldShoppingCart_buttons}
                onClick={() => this.startNewShoppingCart()}
              >
                Start Fresh
              </Button>
            </>
          )}
        </div>
      </Dialog>
    );
  }
}

OldShoppingCartDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  oldShoppingCart_buttons: {
    borderRadius: "30px",
    textAlign: "center",
    padding: "10px 15px",
    background: theme.palette.secondary.main,
    height: 50,
    opacity: "1",
    margin: "10px 0",
    width: "40vw",
  },
});

export default withTheme()(
  withStyles(styles)(withRouter(OldShoppingCartDialog))
);

class ShoppingListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      left: 0,
      fixed: false,
      addOrSubtract: "add",
      yPosition: 0,
      item: props.item,
      timeouts: [],
    };
  }

  componentWillUnmount() {
    this.state.timeouts.map((t) => clearTimeout(t));
  }

  render() {
    const { item, theme } = this.props;

    return (
      <div>
        <ListItem
          className={s.listItem}
          key={item.uuid}
          style={{
            left: this.state.left,
            marginLeft: this.state.left,
          }}
        >
          <div className={s.quantityPrice}>
            <div
              style={{
                fontSize: "1.5rem",
                minWidth: 25,
                color: theme.palette.primary.main,
                fontWeight: "bold",
              }}
            >
              {" "}
              {item.quantity ? item.quantity : 0}
            </div>
            <div style={{ padding: "0 5px 0 5px" }}>x</div>
          </div>
          <Avatar src={getImageUrl(item.imageUrl)} alt={""} />
          <ListItemText
            className={s.listItemText}
            primary={
              <span style={{ fontSize: "smaller" }}>
                {item.brand + " " + item.name}
              </span>
            }
            secondary={`${item.sizeDisplay}`}
          />
          {/* <div className={s.quantityPrice}>
            <div> ${(item.basePrice / 100).toFixed(2)}</div> <div style={{ padding: '0 5px 0 5px' }}>x</div>
            <div> {item.quantityInCart}</div>
          </div>
          <div className={s.itemPrice} style={{ color: theme.palette.primary.main }}>
            ${((parseInt(item.quantityInCart) * parseInt(item.basePrice)) / 100).toFixed(2)}
          </div> */}
        </ListItem>

        <Divider />
      </div>
    );
  }
}
